import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year4/Autumn/PlaceValue/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'PlaceValue',
  field: 'Number',
  weeks: [1, 4],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/PlaceValue/1RepresentNumbersTo1000" */ './1RepresentNumbersTo1000'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/PlaceValue/2PartitionNumbersTo1000" */ './2PartitionNumbersTo1000'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/PlaceValue/3NumberLineTo1000" */ './3NumberLineTo1000'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(/* webpackChunkName: "Year4/Autumn/PlaceValue/4Thousands" */ './4Thousands')
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/PlaceValue/5RepresentNumbersTo10000" */ './5RepresentNumbersTo10000'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/PlaceValue/6PartitionNumbersTo10000" */ './6PartitionNumbersTo10000'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/PlaceValue/7FlexiblePartitioningOfNumbersTo10000" */ './7FlexiblePartitioningOfNumbersTo10000'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/PlaceValue/8Find1To1000MoreOrLess" */ './8Find1To1000MoreOrLess'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/PlaceValue/9NumberLineTo10000" */ './9NumberLineTo10000'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/PlaceValue/10EstimateOnANumberLineTo10000" */ './10EstimateOnANumberLineTo10000'
        )
    }),
    // Step 11
    newSmallStepContent({
      ...BlockModel.smallSteps[10],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/PlaceValue/11CompareNumbersTo10000" */ './11CompareNumbersTo10000'
        )
    }),
    // Step 12
    newSmallStepContent({
      ...BlockModel.smallSteps[11],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/PlaceValue/12OrderNumbersTo10000" */ './12OrderNumbersTo10000'
        )
    }),
    // Step 13
    newSmallStepContent({
      ...BlockModel.smallSteps[12],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/PlaceValue/13RomanNumerals" */ './13RomanNumerals'
        )
    }),
    // Step 14
    newSmallStepContent({
      ...BlockModel.smallSteps[13],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/PlaceValue/14RoundToTheNearest10" */ './14RoundToTheNearest10'
        )
    }),
    // Step 15
    newSmallStepContent({
      ...BlockModel.smallSteps[14],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/PlaceValue/15RoundToTheNearest100" */ './15RoundToTheNearest100'
        )
    }),
    // Step 16
    newSmallStepContent({
      ...BlockModel.smallSteps[15],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/PlaceValue/16RoundToTheNearest1000" */ './16RoundToTheNearest1000'
        )
    }),
    // Step 17
    newSmallStepContent({
      ...BlockModel.smallSteps[16],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/PlaceValue/17RoundToTheNearest10100Or1000" */ './17RoundToTheNearest10100Or1000'
        )
    })
  ]
});
export default Block;
